import React from "react"
import { makeStyles, Typography, Box } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: ({ tiny }) => (tiny ? 10 : 12),
    lineHeight: ({ tiny }) => (tiny ? "13px" : "16px"),
    color: theme.palette.text.light,
  },
}))

const Caption = ({ children, mb = 1.5, className = "", tiny = false, ...rest }) => {
  const classes = useStyles({ tiny })

  return (
    <Box mb={mb} {...rest}>
      <Typography variant="h4" className={`${classes.root} ${className}`}>
        {children}
      </Typography>
    </Box>
  )
}

export { Caption }
